"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.lightTheme = void 0;
var baseTheme_1 = require("./baseTheme");
var buttons_1 = require("./buttons");
var tokens_1 = __importDefault(require("./color/tokens"));
exports.lightTheme = __assign(__assign({}, baseTheme_1.baseTheme), { id: baseTheme_1.ThemeType.LIGHT_THEME, button: buttons_1.buttonLightTheme, colors: __assign(__assign({}, baseTheme_1.baseTheme.colors), { background: {
            card: tokens_1["default"].white,
            cardHover: tokens_1["default"].neutralLight900,
            disabled: tokens_1["default"].glassDark200,
            error: tokens_1["default"].sentimentRed100,
            danger: tokens_1["default"].sentimentRed400,
            frost: tokens_1["default"].glassDark700,
            info: tokens_1["default"].sentimentBlue100,
            input: tokens_1["default"].white,
            inverse: tokens_1["default"].glassDark900,
            primary: tokens_1["default"].neutralDark100,
            secondary: tokens_1["default"].glassDark100,
            skeleton: tokens_1["default"].glassDark300,
            success: tokens_1["default"].sentimentGreen100,
            warning: tokens_1["default"].sentimentOrange100
        }, border: {
            error: tokens_1["default"].sentimentRed200,
            danger: tokens_1["default"].sentimentRed400,
            info: tokens_1["default"].blue700,
            primary: tokens_1["default"].glassDark900,
            secondary: tokens_1["default"].glassDark300,
            success: tokens_1["default"].sentimentGreen200,
            warning: tokens_1["default"].sentimentOrange200
        }, brand: {
            primary: tokens_1["default"].yellow500,
            logo: tokens_1["default"].brown500
        }, outline: {
            focus: tokens_1["default"].glassDark900
        }, sheet: {
            background: tokens_1["default"].white,
            underlay: tokens_1["default"].glassDark100
        }, toast: {
            overlay: tokens_1["default"].glassLight300,
            backgroundColor: tokens_1["default"].neutralDark900,
            textColor: tokens_1["default"].white
        }, toggle: {
            on: tokens_1["default"].blue700,
            off: tokens_1["default"].neutralDark400
        }, text: {
            disabled: tokens_1["default"].glassDark600,
            error: tokens_1["default"].sentimentRed300,
            inverse: tokens_1["default"].white,
            link: tokens_1["default"].blue700,
            linkHover: tokens_1["default"].blue800,
            placeholder: tokens_1["default"].glassDark600,
            primary: tokens_1["default"].brown900,
            secondary: tokens_1["default"].glassDark700,
            success: tokens_1["default"].sentimentGreen300
        }, boxShadow: tokens_1["default"].glassDark200, 
        /**
         * @deprecated do not add further instances of this color
         */
        primary: tokens_1["default"].blue700 }) });
